export default "__VITE_ASSET__CmEGLFzy__"